<template>
  <div>
    <v-app-bar color="white" flat app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer />
      <span style="margin-right: 30px; font-size: 20px; font-weight: 500">
        <v-icon size="23" color="#05523E" style="padding-bottom: 3px"
          >mdi-account-circle</v-icon
        >
        Hello,
        <span style="color: #05523e">{{
          $store.state.account.userInfo.ID
        }}</span>
      </span>
    </v-app-bar>
    <v-navigation-drawer
      v-click-outside="closeNavigator"
      v-model="drawer"
      app
      width="270"
    >
      <img
        style="width: 230px; height: 110px; margin: 10% 6% 6%"
        src="../../assets/logoCa.jpg"
      />
      <v-list nav dense>
        <v-list-item-group
          v-model="$store.state.common.selectedMenu"
          color="#05523E"
        >
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            v-show="item.authority"
            @click="goPage(item.text)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <div>
        <div
          style="position: absolute; bottom: 30px; left: 12px"
          @click="logOut()"
        >
          <v-btn class="elevation-0" color="white">
            <v-icon left> mdi-logout </v-icon>
            Logout
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import { GETCHECKAUTH } from "@/graphql/AccountMutations.js";
import { runGqlMutation } from "@/graphql/gqlUtil.js";
export default {
  name: "Header",
  computed: _.extend(mapState("common", ["menu"])),
  async created() {
    this.pollingCheck();
  },
  mounted() {
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  beforeDestroy() {
    clearInterval(this.pollingTimer);
  },
  data: function () {
    return {
      drawer: false,
      mobileCheck: false,
      pollingTimer: null,
      items: [
        {
          text: "Dashboard",
          icon: "mdi-view-dashboard",
          authority: this.$store.state.common.menu.dashboard,
        },
        {
          text: "Orders",
          icon: "mdi-clipboard-text",
          authority: this.$store.state.common.menu.orders,
        },
        {
          text: "Accounts",
          icon: "mdi-account-multiple",
          authority: this.$store.state.common.menu.accounts,
        },
      ],
    };
  },
  methods: {
    async pollingCheck() {
      const token = localStorage.getItem("token");
      this.pollingTimer = setInterval(async () => {
        const result = await runGqlMutation(GETCHECKAUTH, { token: token });
        if (
          result.message === "GraphQL error: Connection err." ||
          !result.getCheckAuth
        ) {
          // 잘못된 접근
          alert("Wrong approach");
          localStorage.removeItem("token");
          this.$router.replace("/login");
        }
      }, 300000);
    },
    onResize() {
      this.$store.state.common.isMobile = window.innerWidth <= 360;
    },
    isMobile() {
      const user = navigator.userAgent;

      if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
        this.mobileCheck = true;
      }

      return this.mobileCheck;
    },
    async goPage(target) {
      try {
        this.$router.push({ name: target });
      } catch (err) {
        console.error(err);
      }
    },
    closeNavigator(e) {
      if (
        e.target.className === "v-overlay__scrim" &&
        this.$store.state.common.isMobile
      ) {
        this.drawer = false;
        console.log("?");
      }
    },
    logOut() {
      try {
        localStorage.removeItem("token");
        return this.$router.push("/");
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.v-list > div {
  margin-bottom: 10px;
}
.v-list__group__items > div {
  margin-bottom: 5px;
}
.v-list--dense .v-list__tile .v-icon {
  font-size: 28px;
}
.v-icon {
  font-size: 28px;
}
</style>
